import React from 'react';
import { useShowSettings } from '../hooks/useShowSettings';

export const showSettingsHoc = (Component: any) => {
  return (props: any) => {
    const showSettings = useShowSettings();

    return <Component showSettings={showSettings} {...props} />;
  };
};
